export default (value, convertTo = 'capitalize') => {
  let string = value.replace(/([A-Z])/g, ' $1');

  switch (convertTo) {
    // Converts the first character of string to upper case and the remaining to lower case.
    case 'capitalize': {
      string = string.toLowerCase();
      string = string.charAt(0).toUpperCase() + string.slice(1);
      break;
    }

    // Converts string, as space separated words, to lower case.
    case 'lowerCase': {
      string = string.toLowerCase();
      break;
    }

    // Converts string, as space separated words, to upper case.
    case 'upperCase': {
      string = string.toUpperCase();
      break;
    }

    // Converts the first character of each word in string
    // to upper case and the remaining to lower case.
    case 'upperWord': {
      const words = string.toLowerCase().split(' ');

      words.forEach((str, index) => {
        words[index] = str.charAt(0).toUpperCase() + str.slice(1);
      });
      string = words.join(' ');
      break;
    }

    default: {
      string = value;
    }
  }

  return string;
};
